var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.membershiptypeid > 0
    ? _c("div", { attrs: { id: "membershipSection" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12 form-group" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "12",
                    "label-cols-lg": "12"
                  }
                },
                [
                  _vm.membershiptypeid == 3
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(
                          "Oletko MTK:n jäsen (Pohjois-Karjala, Etelä-Savo, Pohjois-Savo)?"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 2
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v("Oletko Suomen Omakotiliiton jäsen?")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 4
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(
                          "Onko Asunto-osakeyhtiösi Kiinteistöliitto Itä-Suomen jäsen?"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 5
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v("Oletko Pohjois-Karjalan Yrittäjien jäsen?")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 6
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(
                          "Onko sinulla toistaiseksi voimassa oleva työsuhde PKS:n tai sen tytäryhtiön kanssa?"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 7
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v("Oletko PKS:n kumppani?")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 8
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(
                          "Oletko Metsänhoitoyhdistys Pohjois-Karjalan jäsen?"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 9
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v("Oletko Suomen Lions -liiton jäsen?")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.membershiptypeid == 10
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v("Oletko Suomen Vuokranantajien jäsen?")
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-check-inline",
                  staticStyle: { "margin-top": "0" }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "member-yes" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.membershipchoice,
                            expression: "membershipchoice"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "membershiptype",
                          id: "member-yes",
                          value: "1"
                        },
                        domProps: {
                          checked: _vm._q(_vm.membershipchoice, "1")
                        },
                        on: {
                          change: function($event) {
                            _vm.membershipchoice = "1"
                          }
                        }
                      }),
                      _vm._v(" Kyllä\n                ")
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-check-inline",
                  staticStyle: { "margin-top": "0" }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "member-no" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.membershipchoice,
                            expression: "membershipchoice"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "membershiptype",
                          id: "member-no",
                          value: "0"
                        },
                        domProps: {
                          checked: _vm._q(_vm.membershipchoice, "0")
                        },
                        on: {
                          change: function($event) {
                            _vm.membershipchoice = "0"
                          }
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.membership_choise) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.membershipchoice > 0
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _vm.membershiptypeid == 3
                  ? _c("span", [
                      _vm._v(
                        "MTK-jäsenetu 100 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 2
                  ? _c("span", [
                      _vm._v(
                        "Omakotiliiton jäsenetu 50 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 4
                  ? _c("span", [
                      _vm._v(
                        "Kiinteistöliiton jäsenetu 100 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 5
                  ? _c("span", [
                      _vm._v(
                        "Yrittäjien jäsenetu 100 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 6
                  ? _c("span", [
                      _vm._v(
                        "PKS Henkilöstöetu 100 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 7
                  ? _c("span", [
                      _vm._v(
                        "PKS kumppanin etu 100 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 8
                  ? _c("span", [
                      _vm._v(
                        "MHY-jäsenetu 50 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 9
                  ? _c("span", [
                      _vm._v(
                        "Lions-Clubin jäsenetu 50 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.membershiptypeid == 10
                  ? _c("span", [
                      _vm._v(
                        "Vuokranantajien jäsenetu 50 % alennus alla olevista kuukausimaksusta"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }